module.exports = __webpack_public_path__ + "img/FAV_0152.f7c33d51.jpg";